import { useEffect, useState } from 'react';
import { getSchedule } from './api';
import SectionHeader from './SectionHeader';

const REPEAT_LABELS = {
  week:     'еженедельно',
  month:    'ежемесячно',
  '2months':'раз в 2 мес.',
  daily:    'ежедневно',
  alt_day:  'через день',
  every3d:  'через 2 дня',
};

export default function ScheduleBlock({ petId, pdfPath, pdfName, docs, onDocsClick }) {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getSchedule(petId)
      .then(setEvents)
      .catch(() => setEvents([]))
      .finally(() => setLoading(false));
  }, [petId]);

  if (loading) return null;

  const routines = events.filter(e => e.is_routine);
  const regular  = events.filter(e => !e.is_routine);

  return (
    <section className="card-section" id="section-schedule">
      <SectionHeader
        title="Расписание"
        pdfPath={pdfPath}
        pdfName={pdfName}
        sectionKey="schedule"
        docs={docs}
        onDocsClick={onDocsClick}
      />

      {events.length === 0 && (
        <p style={{ color: '#888', fontSize: 14, margin: 0 }}>Нет предстоящих событий</p>
      )}

      {routines.length > 0 && (
        <div className="schedule-group">
          <div className="schedule-group-title">⏰ Рутина</div>
          {routines.map((event, i) => (
            <div key={i} className="schedule-row">
              <div className="schedule-desc">
                {event.description}
                {event.event_time && (
                  <span className="schedule-time">{event.event_time}</span>
                )}
                {event.repeat_type && (
                  <span className="schedule-repeat">
                    🔁 {REPEAT_LABELS[event.repeat_type] || event.repeat_type}
                  </span>
                )}
              </div>
              <div className="schedule-dates">
                {event.dates[0] && (
                  <span className="schedule-date schedule-date-next">{event.dates[0]}</span>
                )}
                {event.end_date && (
                  <span className="schedule-date schedule-date-end">до {event.end_date}</span>
                )}
              </div>
            </div>
          ))}
        </div>
      )}

      {regular.length > 0 && (
        <div className="schedule-group">
          {routines.length > 0 && (
            <div className="schedule-group-title">📅 События</div>
          )}
          {regular.map((event, i) => (
            <div key={i} className="schedule-row">
              <div className="schedule-desc">
                {event.description}
                {event.repeat_type && (
                  <span className="schedule-repeat">
                    🔁 {REPEAT_LABELS[event.repeat_type] || event.repeat_type}
                  </span>
                )}
              </div>
              <div className="schedule-dates">
                {event.dates.map((d, j) => (
                  <span key={j} className={`schedule-date ${j === 0 ? 'schedule-date-next' : ''}`}>
                    {d}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
